import React from 'react';
import { useProfileCourses } from '../../../hooks';
import { CoursesFilterBox, IBLSpinLoader } from '../../../components';
import './CourseViewContent.css';
import { NoItemView } from '../../NoItemView';
import _ from 'lodash';
export const CourseViewContent = ({ username }) => {
  const [userCourses, userCoursesLoaded] = useProfileCourses(username);
  return (
    <span>
      <div
        className="ov_panel active"
        data-name="cs"
        style={{ marginTop: '20px' }}
      >
        <div className="br_cont">
          <div className="div-block-483">
            <div className="text-block-278">Courses in Progress</div>
          </div>
          {!userCoursesLoaded ? (
            <IBLSpinLoader size={40} containerHeight={'200px'} />
          ) : !_.isEmpty(userCourses) ? (
            <div className="br_row">
              <div className="div-block-430 sl pathway_grid">
                <CoursesFilterBox
                  discoverItems={userCourses}
                  discoverLoaded={userCoursesLoaded}
                ></CoursesFilterBox>
              </div>
            </div>
          ) : (
            <NoItemView
              displayMessage="You don't have any courses yet."
              displayPadding={true}
            />
          )}
        </div>
      </div>
    </span>
  );
};
